// New context to cache artists list globally and avoid refetching on every route navigation
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const ArtistsContext = createContext(null);

export const ArtistsProvider = ({ children }) => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchedRef = useRef(false);

  const fetchArtists = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await fetch('https://api.musicalmeet.com/api/artists');
      if (!res.ok) throw new Error('Network error');
      const data = await res.json();
      setArtists(data || []);
    } catch (e) {
      setError('Failed to load artists.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fetchedRef.current) return; // ensure single fetch per app load
    fetchedRef.current = true;
    fetchArtists();
  }, []);

  const refresh = () => fetchArtists();

  return (
    <ArtistsContext.Provider value={{ artists, setArtists, loading, error, refresh }}>
      {children}
    </ArtistsContext.Provider>
  );
};

export const useArtists = () => {
  const ctx = useContext(ArtistsContext);
  if (!ctx) throw new Error('useArtists must be used within ArtistsProvider');
  return ctx;
};
